import {getMethod} from '~/api'

async function get(orderId, request) {
    return await getMethod(`/api/order/${orderId}/messages`, request)
}

export {get}
